import React, { useEffect, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useShallow } from 'zustand/react/shallow';

import { useOrdersStore } from '@app/store/zustand';

import { AssetOrderModal } from '../AssetOrderModal';
import { AssetOrderSheet } from '../AssetOrderSheet';

export function MarketplaceOverlays() {
    const {
        orderType,
        token,
        confirmedToken,
        removeToken,
        pendingConfirmation,
        setPendingConfirmation,
        removeConfirmedToken,
    } = useOrdersStore(useShallow((state) => state));

    const [showOrderSheet, setShowOrderSheet] = useState(false);
    const [showOrderModal, setShowOrderModal] = useState(false);

    useEffect(() => {
        const canRenderSheet = !!token && (orderType === 'list' || orderType === 'offer');
        setShowOrderSheet(canRenderSheet);
    }, [orderType, token]);

    useEffect(() => {
        let shouldRenderModal: boolean;
        switch (orderType) {
            case 'sell':
            case 'buy': {
                shouldRenderModal = Boolean((token && pendingConfirmation) || confirmedToken);
                break;
            }
            case 'list':
            case 'offer': {
                shouldRenderModal = Boolean(confirmedToken) || pendingConfirmation;
                break;
            }
            default: {
                shouldRenderModal = false;
            }
        }

        setShowOrderModal(shouldRenderModal);
    }, [confirmedToken, orderType, pendingConfirmation, token]);

    function handleCloseSheet() {
        if (token && !pendingConfirmation) {
            removeToken();
        }
        setShowOrderSheet(false);
    }
    function handleCloseModal() {
        if (pendingConfirmation && confirmedToken) {
            setPendingConfirmation(false);
        }

        if (confirmedToken) {
            removeConfirmedToken();
        }
        setShowOrderModal(false);
    }

    const modalAsset = token ?? confirmedToken;
    const modalType = confirmedToken ? 'post' : 'pre';

    return (
        <AnimatePresence>
            {showOrderSheet && <AssetOrderSheet onClose={() => handleCloseSheet()} />}
            {showOrderModal && (
                <AssetOrderModal
                    key={`AssetOrderModal-${orderType}`}
                    type={modalType}
                    asset={modalAsset}
                    onClose={() => handleCloseModal()}
                    orderType={orderType}
                />
            )}
        </AnimatePresence>
    );
}
